const _MS_PER_MINUTE = 1000 * 60
const _MS_PER_SECOND = 1000
const _MINUTE_PER_HOUR = 60
const _MINUTE_PER_DAY = _MINUTE_PER_HOUR * 24
const _MINUTE_PER_WEEK = _MINUTE_PER_DAY * 7
const _MINUTE_PER_MONTH = _MINUTE_PER_WEEK * 4
const _MINUTE_PER_YEAR = _MINUTE_PER_MONTH * 12

function pluralize (noun, count) {
  if (count < 0) { throw new Error('Object count cannot be negative.') }
  if (count <= 1) { return noun }

  return `${noun}s`
}

// Using the unit for time difference.
function dateDiff (date1, date2) {
  const diffMinutes = Math.abs(Math.floor((date1 - date2) / _MS_PER_MINUTE))

  if (diffMinutes < 60) {
    return `${diffMinutes} ${pluralize('minute', diffMinutes)} ago.`
  } else if (diffMinutes >= 60 && diffMinutes < _MINUTE_PER_DAY) {
    const diffHours = Math.floor(diffMinutes / _MINUTE_PER_HOUR)
    return `${diffHours} ${pluralize('hour', diffHours)} ago.`
  } else if (diffMinutes >= _MINUTE_PER_DAY && diffMinutes < _MINUTE_PER_WEEK) {
    const diffDays = Math.floor(diffMinutes / _MINUTE_PER_DAY)
    return `${diffDays} ${pluralize('day', diffDays)} ago.`
  } else if (diffMinutes >= _MINUTE_PER_WEEK && diffMinutes < _MINUTE_PER_MONTH) {
    const diffWeeks = Math.floor(diffMinutes / _MINUTE_PER_WEEK)
    return `${diffWeeks} ${pluralize('week', diffWeeks)} ago.`
  } else if (diffMinutes >= _MINUTE_PER_MONTH && diffMinutes < _MINUTE_PER_YEAR) {
    const diffMonths = Math.floor(diffMinutes / _MINUTE_PER_MONTH)
    return `${diffMonths} ${pluralize('month', diffMonths)} ago.`
  } else {
    const diffYears = Math.floor(diffMinutes / _MINUTE_PER_YEAR)
    return `${diffYears} ${pluralize('year', diffYears)} ago.`
  }
}

// Adds a '0' preffix to a number if it is less than 10.
function padZero (number) {
  return number < 10 ? `0${number}` : number
}

// Builds a counter for a deadline in HH::MM::SS format.
function buildCounter (deadline, now) {
  const diffSeconds = Math.abs(Math.floor((deadline - now) / _MS_PER_SECOND))
  const diffMinutes = Math.floor(diffSeconds / _MINUTE_PER_HOUR)
  const diffHours = Math.floor(diffMinutes / _MINUTE_PER_HOUR)

  return `${padZero(diffHours)}:${padZero(diffMinutes % _MINUTE_PER_HOUR)}:${padZero(diffSeconds % _MINUTE_PER_HOUR)}`
}

const dateUtil = {
  computed: {
    publishedSince () {
      return dateDiff(Date.now(), this.publishedAt)
    }
  },
  methods: {
    buildCounter
  }
}

export { dateUtil }
